// PR-28: per-project cards-list cache for instant render on MobileCards
// mount. Write-through after each successful network fetch; the network
// fetch always wins on conflict (last-writer for the project).

import type { Card } from '../api'
import { getValue, putValue } from './indexed_db'

const STORE = 'cards_by_project'

interface CardsCacheEntry {
  project_id: string
  cards: Card[]
  cached_at: number
}

export async function read(projectId: string): Promise<Card[] | undefined> {
  const entry = await getValue<CardsCacheEntry>(STORE, projectId)
  return entry?.cards
}

export async function write(projectId: string, cards: Card[]): Promise<void> {
  const entry: CardsCacheEntry = {
    project_id: projectId,
    cards,
    cached_at: Date.now(),
  }
  await putValue(STORE, entry)
}
